import React, { useState } from "react";
import RecruiterUser from "../../../../apiResources/RecruiterUser";
import Recruiter from "../../../../apiResources/Recruiter";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Employer from "../../../../apiResources/Employer";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import JobTypeSettingOption from "../../../settings/JobTypeSettingOption";
import JobNotificationSettingOption from "../../../settings/JobNotificationSettingOption";
import SectorsSettingOption from "../../../settings/SectorsSettingOption";
import Divider from "../../../library/Divider";
import Loader from "../../../library/Loader";

const Preferences = (props: Props) => {
  const { user, company } = props;

  const [editFocus, setEditFocus] = useState<string>(null);
  const resetEditFocus = () => setEditFocus(null);

  const isEditing = (key) => Boolean(editFocus) && editFocus === key;
  const isDisabled = (key) => Boolean(editFocus) && editFocus !== key;

  if (!user) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Preferences</SettingsHeading>
      {user.isRecruiter ? (
        <>
          <JobTypeSettingOption
            user={user as RecruiterUser}
            isEditing={isEditing("jobType")}
            disabled={isDisabled("jobType")}
            onEdit={() => setEditFocus("jobType")}
            onDone={resetEditFocus}
          />
          <Divider />
          <JobNotificationSettingOption
            user={user as RecruiterUser}
            disabled={isDisabled("jobNotification")}
          />
          <Divider />
          <SectorsSettingOption user={user as RecruiterUser} />
        </>
      ) : (
        <div>There is nothing here</div>
      )}
    </SettingsLayout>
  );
};

type Props = {
  user: RecruiterUser | EmployerUser;
  company: Recruiter | Employer;
};

export default Preferences;
